export const IS_DARK_THEME = Symbol('is-dark-theme') as unknown as boolean;
export const IS_COMMUNITY = Symbol('is-community') as unknown as boolean;
export const IS_ENTERPRISE = Symbol('is-enterprise') as unknown as boolean;
export const DEFAULT_SEPARATION_LINES_COLOUR = Symbol('default-separation-lines-colour') as unknown as string;
export const DEFAULT_SHADOW_COLOUR = Symbol('default-shadow-colour') as unknown as string;
export const DEFAULT_CAPTION_LAYOUT_STYLE = Symbol('default-caption-layout-style') as unknown as string;
export const DEFAULT_CAPTION_ALIGNMENT = Symbol('default-caption-alignment') as unknown as string;
export const PALETTE_UP_STROKE = Symbol('palette-up-stroke') as unknown as string;
export const PALETTE_DOWN_STROKE = Symbol('palette-down-stroke') as unknown as string;
export const PALETTE_UP_FILL = Symbol('palette-up-fill') as unknown as string;
export const PALETTE_DOWN_FILL = Symbol('palette-down-fill') as unknown as string;
export const PALETTE_NEUTRAL_STROKE = Symbol('palette-neutral-stroke') as unknown as string;
export const PALETTE_NEUTRAL_FILL = Symbol('palette-neutral-fill') as unknown as string;
export const PALETTE_ALT_UP_STROKE = Symbol('palette-alt-up-stroke') as unknown as string;
export const PALETTE_ALT_DOWN_STROKE = Symbol('palette-alt-down-stroke') as unknown as string;
export const PALETTE_ALT_UP_FILL = Symbol('palette-alt-up-fill') as unknown as string;
export const PALETTE_ALT_DOWN_FILL = Symbol('palette-alt-down-fill') as unknown as string;
export const PALETTE_ALT_NEUTRAL_FILL = Symbol('palette-gray-fill') as unknown as string;
export const PALETTE_ALT_NEUTRAL_STROKE = Symbol('palette-gray-stroke') as unknown as string;

export const DEFAULT_POLAR_SERIES_STROKE = Symbol('default-polar-series-stroke') as unknown as string;
export const DEFAULT_SPARKLINE_CROSSHAIR_STROKE = Symbol('default-sparkline-crosshair-stroke') as unknown as string;
export const DEFAULT_FINANCIAL_CHARTS_ANNOTATION_COLOR = Symbol(
    'default-financial-charts-annotation-stroke'
) as unknown as string;
export const DEFAULT_FIBONACCI_STROKES = Symbol('default-hierarchy-strokes') as unknown as string;
export const DEFAULT_TEXT_ANNOTATION_COLOR = Symbol('default-text-annotation-color') as unknown as string;
export const DEFAULT_FINANCIAL_CHARTS_ANNOTATION_BACKGROUND_FILL = Symbol(
    'default-financial-charts-annotation-background-fill'
) as unknown as string;
export const DEFAULT_ANNOTATION_HANDLE_FILL = Symbol('default-annotation-handle-fill') as unknown as string;
export const DEFAULT_ANNOTATION_STATISTICS_FILL = Symbol('default-annotation-statistics-fill') as unknown as string;
export const DEFAULT_ANNOTATION_STATISTICS_STROKE = Symbol('default-annotation-statistics-stroke') as unknown as string;
export const DEFAULT_ANNOTATION_STATISTICS_COLOR = Symbol('default-annotation-statistics-color') as unknown as string;
export const DEFAULT_ANNOTATION_STATISTICS_DIVIDER_STROKE = Symbol(
    'default-annotation-statistics-divider-stroke'
) as unknown as string;
export const DEFAULT_ANNOTATION_STATISTICS_DOWN_FILL = Symbol(
    'default-annotation-statistics-fill'
) as unknown as string;
export const DEFAULT_ANNOTATION_STATISTICS_DOWN_STROKE = Symbol(
    'default-annotation-statistics-stroke'
) as unknown as string;
export const DEFAULT_TEXTBOX_FILL = Symbol('default-textbox-fill') as unknown as string;
export const DEFAULT_TEXTBOX_STROKE = Symbol('default-textbox-stroke') as unknown as string;
export const DEFAULT_TEXTBOX_COLOR = Symbol('default-textbox-color') as unknown as string;
export const DEFAULT_TOOLBAR_POSITION = Symbol('default-toolbar-position') as unknown as string;
export const DEFAULT_GRIDLINE_ENABLED = Symbol('default-gridline-enabled') as unknown as string;
